export class Equipment {
  id:string;
  core_Id = null;
  location_Id: string;
  sublocation_Id: string;
  description: string;
  serial_Num: string;
  asset_Num: string;
  swl: string;
  manufacturer_Id: number;
  date_Of_Manufacture: string;
  category_Id: string;
  other_Details: string;
  expired = false;
  is_edit = false;
  selected = false;
  inspection: any;

  addedEquipment:Equipment[]

}
